import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21cd9392"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "review-card-list-wrapper"
}
const _hoisted_2 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-4 tw-mb-8" }
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-2 tw-min-h-[85px] tw-justify-center" }
const _hoisted_4 = { class: "review-card-list" }
const _hoisted_5 = {
  key: 1,
  class: "empty__content !tw-pb-12 !tw-box-border !tw-h-auto"
}
const _hoisted_6 = { class: "empty__banner tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_7 = { class: "empty__banner__img md:!tw-w-[50%]" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "empty__banner__content !tw-mt-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "md:!tw-leading-[30px]" }, [
  /*#__PURE__*/_createTextVNode(" You don't have any"),
  /*#__PURE__*/_createElementVNode("br", { class: "tw-hidden md:!tw-flex" }),
  /*#__PURE__*/_createTextVNode(" review yet! ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Complete new jobs and receive reviews"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" from the clients. ")
], -1))
const _hoisted_12 = { class: "empty__banner__footer tw-w-full rmd:!tw-mt-6" }
const _hoisted_13 = {
  key: 1,
  class: "empty__banner__content"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" Don't have any"),
  /*#__PURE__*/_createElementVNode("br", { class: "tw-hidden md:!tw-flex" }),
  /*#__PURE__*/_createTextVNode(" review yet! ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "All review listings will be displayed here.", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

import { WORKSTATION } from "@/store/modules/workstation";
import projectReviewModal from "@/modules/trade-passport/components/modals/projectReviewModal.vue";
import projectReviewCommentModal from "@/modules/trade-passport/components/modals/projectReviewCommentModal.vue";
import ProjectReviewCard from "@/modules/trade-passport/components/cards/ProjectReviewCard.vue";
import Loader from "@/core/components/common/Loader.vue";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { JOBS_ROUTE } from "@/modules/jobs/routes";
import { useRouter } from "vue-router";
import { ProjectRatingTypeEnum } from "@/core/enums/ProjectsEnum";
import { REVIEW_RATING_STORE } from "@/store/modules/review-rating";
import { reviewRatingState } from "@/core/models/project-rating";
import { UserRolesEnum } from "@/core/enums/RolesEnum";
import { USER_STORE } from "@/store/modules/user";
import { getCombineSameProjectReview } from "@/core/utils/common";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import Text from "@/core/components/ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradePassportReviews',
  setup(__props) {

const store = useStore();
const router = useRouter();
const isShowReviewModal = ref(false);
const isLoading = ref(false);
const isShowReviewCommentModal = ref(false);
const selectedProjectReviewData = ref();
const getUserWorkStationFieldAccess = computed(
  () => store.getters[`${WORKSTATION}/getUserWorkStationFieldAccess`]
);
const toggleReviewModal = () => {
  isShowReviewModal.value = !isShowReviewModal.value;
};
const toggleReviewCommentModal = () => {
  isShowReviewCommentModal.value = !isShowReviewCommentModal.value;
};

const onClickViewDetail = (reviewData: any) => {
  selectedProjectReviewData.value = reviewData;
  toggleReviewModal();
  isShowReviewCommentModal.value = false;
};
const onClickViewCommentDetail = (reviewData: any) => {
  selectedProjectReviewData.value = reviewData;
  toggleReviewCommentModal();
  isShowReviewModal.value = false;
};
const onClickGotoJobPage = () => {
  router.push({ name: JOBS_ROUTE });
};
const getAllProjectReviewList = computed<
  reviewRatingState["allProjectReviewList"]
>(() => store.getters[`${REVIEW_RATING_STORE}/getAllProjectReviewList`]);

const combineSameProjectReview = computed(() =>
  getCombineSameProjectReview(getAllProjectReviewList.value)
);
const setAllProjectReviewList = async () => {
  try {
    isLoading.value = true;
    await store.dispatch(
      `${REVIEW_RATING_STORE}/getAllProjectReviewList`,
      ProjectRatingTypeEnum.TRADER_OWNER
    );
  } catch (error) {
    console.log("all review list", error);
  } finally {
    isLoading.value = false;
  }
};

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const getIsOpenTradePassportasViewMode = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/isOpenTradePassportasViewMode`]
);

const getAverageOfAllProjectReview = computed(() => {
  const totalAvg = combineSameProjectReview.value.reduce(
    (totalRating: number, review: any) => {
      totalRating += review.totalAvg || 0;
      return totalRating;
    },
    0
  );
  return totalAvg
    ? Math.round((totalAvg * 100) / combineSameProjectReview.value.length) / 100
    : totalAvg;
});

const isUserProprtyOwner = computed(
  () =>
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER ||
    getIsOpenTradePassportasViewMode.value
);
onMounted(async () => {
  if (!getAllProjectReviewList.value?.length) {
    await setAllProjectReviewList();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (combineSameProjectReview.value?.length && !isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Text, {
              variant: "h6",
              class: "rmd:!tw-text-[20px]"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Overall Rating ")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(Text, {
                variant: "h2",
                class: "rmd:!tw-text-[56px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getAverageOfAllProjectReview.value), 1),
                  _createVNode(Text, {
                    variant: "h6",
                    class: "rmd:!tw-text-[18px]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("/5")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_rating, {
                "active-color": "orange",
                modelValue: getAverageOfAllProjectReview.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((getAverageOfAllProjectReview).value = $event)),
                color: "rgba(12, 15, 74, 0.26)",
                "empty-icon": "mdi-star",
                readonly: "",
                size: 23
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combineSameProjectReview.value, (review) => {
              return (_openBlock(), _createBlock(ProjectReviewCard, {
                key: review.project.id,
                reviewData: review,
                onOnViewDetail: ($event: any) => (onClickViewDetail(review)),
                onOnViewComment: ($event: any) => (onClickViewCommentDetail(review))
              }, null, 8, ["reviewData", "onOnViewDetail", "onOnViewComment"]))
            }), 128))
          ])
        ]))
      : (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: require('../../../assets/images/review-empty.png'),
                  alt: "",
                  class: "tw-w-full"
                }, null, 8, _hoisted_8)
              ]),
              (!isUserProprtyOwner.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      (getUserWorkStationFieldAccess.value && !isUserProprtyOwner.value)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "button button-purple",
                            width: "100%",
                            onClick: onClickGotoJobPage
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Find New Jobs")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
            ])
          ]))
        : _createCommentVNode("", true),
    _createVNode(Loader, { show: isLoading.value }, null, 8, ["show"]),
    (isShowReviewModal.value)
      ? (_openBlock(), _createBlock(projectReviewModal, {
          key: 2,
          reviewData: selectedProjectReviewData.value,
          onOnClose: toggleReviewModal,
          onOnViewComment: _cache[1] || (_cache[1] = ($event: any) => (onClickViewCommentDetail(selectedProjectReviewData.value)))
        }, null, 8, ["reviewData"]))
      : _createCommentVNode("", true),
    (isShowReviewCommentModal.value)
      ? (_openBlock(), _createBlock(projectReviewCommentModal, {
          key: 3,
          reviewData: selectedProjectReviewData.value,
          onOnClose: toggleReviewCommentModal
        }, null, 8, ["reviewData"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})